import { WorkPropertyVisibleResponse, } from '../dto/ResDtoRepository';
import { UpdateWorkPropertyVisibleReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


export const getWorkPropertyVisible = async (aui: string): Promise<WorkPropertyVisibleResponse> => {
  return sendGetApiRequest<WorkPropertyVisibleResponse>(`/api/v1/work-property?aui=${aui}`);
};

export const updateWorkPropertyVisible = async (aui: string, data: UpdateWorkPropertyVisibleReq): Promise<WorkPropertyVisibleResponse> => {
  return sendApiRequest<WorkPropertyVisibleResponse>('put', `/api/v1/work-property?aui=${aui}`, data);
};
